import { createGlobalStyle } from "styled-components"

export const primaryColor = "#CEDADC" // Platinum
export const secondaryColor = "#547D84" // Myrtle green
export const darkGrey = "#161314" // Night
export const medGrey = "#97878C" // Platinum
export const lightMedGrey = "#97878C" // Platinum
export const lightGrey = "#FFFFF0" //Ivory

export const fontFamily = "Belleza"
export const fontSizeM = "1rem"
export const fontSizeS = "0.8rem"

export const GlobalStyle = createGlobalStyle`

    :root {
        --maxWidth: 1280px;
        --white: #fff;
        --lightGrey: ${lightGrey};
        --lightMedGrey: ${lightMedGrey};
        --medGrey: ${medGrey};
        --darkGrey: ${darkGrey};
        --black: #0e1111;
        --blue: #251cc5;
        --red: #b70000;
        --green: #2f6746;
        --grey:rgb(160, 160, 160);
        --orange: #ff8642;
        --yellow: #fed800;
        --purple: #aa94de;
        --pink:rgb(253, 144, 193);
        --brown: #5b3a29;
        --white: ${lightGrey};
        --transparent: rgba(255, 255, 255, 0.1);
        --primary: ${primaryColor}; 
        --secondary: ${secondaryColor};
        --fontXL: 2rem;
        --fontL: 1.2rem;
        --fontM: ${fontSizeM};
        --fontS: ${fontSizeS};
        --fontXS: 0.5rem;
    }

    * {
        box-sizing: border-box;
        margin: 0;
        font-family: ${fontFamily}, sans-serif;
    }

    body {
        margin: 0;
        padding: 0;
        color: ${darkGrey};
        background-color: ${lightGrey};
        overflow-x: hidden;

        h1 {
            font-size: 2rem;
            font-weight: 600;
        }

        h3 {
            font-size: 1.2rem;
            font-weight: 600;
        }

        p {
            font-size: 1rem;
        }
    }
`

export const lightTheme = {
   name: "light",
   body: lightGrey,
   highLight: lightMedGrey,
   text: darkGrey,
   primary: primaryColor,
   secondary: secondaryColor,
}
